
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 497 497"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M53.5 476c0 14 6.833 21 20.5 21s20.5-7 20.5-21V287h21v189c0 14 6.834 21 20.5 21 13.667 0 20.5-7 20.5-21V154h10v116c0 7.334 2.5 12.667 7.5 16s10.167 3.333 15.5 0 8-8.667 8-16V145c0-13.334-4.5-23.667-13.5-31s-21.5-11-37.5-11h-82c-15.333 0-27.833 3.333-37.5 10s-14.5 17-14.5 31v133c0 6 2.667 10.333 8 13s10.5 2.667 15.5 0 7.5-7 7.5-13V154h10v322zM462.5 323l-60-166c-.667-.667-1-1.333-1-2 0-3.333 1.667-5 5-5 2 0 3.333 1.333 4 4l41 107c3.337 7.333 10.67 11 22 11 4 0 6.833-3 8.5-9s2.5-10 2.5-12l-42-103c-1.333-12.667-7.333-23.333-18-32s-23-13-37-13h-53c-14 0-26.5 4.5-37.5 13.5S279.5 136 277.5 148l-39 104c-1.333 2-1 5.833 1 11.5s5 8.5 9 8.5c12.667 0 20-3.333 22-10l40-108c.667-2 2-3 4-3 2.667 0 4 1.333 4 4v1l-59 167v13c0 1.334 1.667 3.668 5 7 3.338 3.333 5.671 5 7 5h38v129c0 5.333 2.167 10 6.5 14 4.336 4 9.169 6 14.5 6 5.333 0 10-2 14-6s6-8.667 6-14V343c0-.667 1.833-1.167 5.5-1.5s7.167-.333 10.5 0c3.333.337 5 .837 5 1.5v133c0 5.333 2 10.167 6 14.5s8.833 6.5 14.5 6.5 10.5-2.167 14.5-6.5 6-9.167 6-14.5V348h39c2 0 4.333-1.667 7-5s4-5.667 4-7v-13zM61.5 42.5c0 11.667 4.167 21.667 12.5 30S92.333 85 104 85s21.667-4.167 30-12.5S146.5 54 146.5 42c0-11.335-4.167-21.168-12.5-29.5C125.667 4.167 115.667 0 104 0S82.333 4.167 74 12.5s-12.5 18.333-12.5 30zM317.5 42.5c0 11.667 4.167 21.667 12.5 30S348.333 85 360 85s21.667-4.167 30-12.5 12.5-18.333 12.5-30-4.167-21.667-12.5-30S371.667 0 360 0s-21.667 4.167-30 12.5-12.5 18.333-12.5 30z"}})])])
          )
        }
      }
    